import SliceManager from 'components/shared/SliceManager'
import UseCaseHero from 'components/shared/UseCaseHero'
import React from 'react'
import { getDataDependencies, buildStaticPaths } from 'services/api'

import fetchAllSlugs from 'src/lib/Strapi/fetchAllSlugs'
import PreviewBanner from 'src/components/shared/PreviewBanner'

import delve from 'dlv'
import fetchContentType from 'src/lib/Strapi/fetchContentType'

const UseCase = ({ pageData, preview }) => {
  const useCaseHero = delve(pageData, 'useCaseHero')
  const slices = delve(pageData, 'slices')

  return (
    <>
      {preview && <PreviewBanner />}
      {useCaseHero && <UseCaseHero {...useCaseHero} />}
      {slices && <SliceManager slices={slices} />}
    </>
  )
}

export async function getStaticPaths() {
  const data = await fetchAllSlugs('use-cases')
  return buildStaticPaths(data, 'solutions')
}

export async function getStaticProps({ preview = null, params }) {
  const data = await fetchContentType(
    'use-cases',
    `filters[slug]=${params.slug}${
      preview ? '&publicationState=preview' : ''
    }`
  )
  const pageData = await getDataDependencies(delve(data, '0'))

  if (data?.length === 0 || !data) {
    return {
      props: {},
      notFound: true,
    }
  }

  return {
    props: {
      pageData,
      preview,
    },
  }
}

export default UseCase
